import Truckers from 'views/Truckers/Truckers.jsx';
import AddTruckers from 'views/Truckers/AddTruckers.jsx';

import Transactions from 'views/Transactions/BranchOpsTransactions.jsx';
import AddTransactions from 'views/Transactions/AddTransactions.jsx';

import LocalShipping from '@material-ui/icons/LocalShipping';
import SwapHoriz from '@material-ui/icons/SwapHoriz';

// @material-ui/icons
import DashboardIcon from '@material-ui/icons/Dashboard';
import DashboardRedirect from '../views/Dashboard/DashboardRedirect';

const branchOpsRoutes = [
  {
    path: '/branch-ops/dashboard',
    name: 'Dashboard',
    icon: DashboardIcon,
    component: DashboardRedirect,
  },
  {
    collapse: true,
    path: '/branch-ops/truckers',
    name: 'Truckers',
    icon: LocalShipping,
    state: 'openTruckers',
    views: [
      {
        path: '/branch-ops/truckers/view',
        name: 'View',
        mini: 'V',
        component: Truckers,
      },
      {
        path: '/branch-ops/truckers/add',
        name: 'Add',
        mini: 'A',
        component: AddTruckers,
      },
    ],
  },
  {
    collapse: true,
    path: '/branch-ops/transactions',
    name: 'Transactions',
    icon: SwapHoriz,
    state: 'openTransactions',
    views: [
      {
        path: '/branch-ops/transactions/view',
        name: 'View',
        mini: 'V',
        component: Transactions,
      },
      {
        path: '/branch-ops/transactions/add',
        name: 'Add',
        mini: 'A',
        component: AddTransactions,
      },
    ],
  },
  {
    redirect: true,
    path: '/branch-ops',
    pathTo: '/branch-ops/dashboard',
    name: 'Dashboard',
  },
];
export default branchOpsRoutes;
